import React from "react";
import Select from "react-select";
import { CheckedPinIcon, PinIcon } from "../../svg";

const options = [

];

export default function NormalSelect({
    defaultValue,
    filter,
    handleChange,
    styles = {},
    ...rest
}) {
    function hexToRgba(hex, alpha = 0.5) {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
    return (
        <div className="relative w-[402px]" style={styles}>
            <Select
                isMulti={filter?.isMulti || false}
                defaultValue={defaultValue || null}
                maxMenuHeight={200}
                options={filter?.options || options}
                format="YYYY/MM/DD"
                onChange={(e) => {
                    if (filter?.isMulti) {
                        e.value = e.map(e => e.value);
                    }
                    handleChange(e);
                }}
                formatOptionLabel={
                    filter?.name === "Filter by Status" || "shipmentTypes"
                        ? (data) => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div
                                    style={{
                                        width: 10,
                                        height: 10,
                                        backgroundColor: data.color || 'transparent',
                                        borderRadius: '50%',
                                        marginRight: 8,
                                    }}
                                />
                                {data.label}
                            </div>
                        )
                        : undefined
                }
                styles={{
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 999,
                        backgroundColor: "white"
                    }),
                    valueContainer: (base) => ({
                        ...base,
                        marginLeft: 0,
                        marginTop: "4px",
                        marginBottom: "2px"
                    }),
                    control: (base) => ({
                        ...base,
                        minHeight: "40px",
                        flexWrap: "wrap"
                    }),
                    ...(filter?.name === "Filter by Status" || "shipmentTypes"
                        ? {
                            multiValue: (base, state) => ({
                                ...base,
                                backgroundColor: hexToRgba(state.data.color || "#d3d3d3", 0.3),
                                color: '#fff'
                            }),
                            multiValueLabel: (base, state) => ({
                                ...base,
                                color: state.data.color || '#fff'
                            }),
                            multiValueRemove: (base, state) => ({
                                ...base,
                                color: state.data.color || '#000',
                                ':hover': {
                                    backgroundColor: state.data.color || '#ccc',
                                    color: '#fff'
                                }
                            })
                        }
                        : {})
                }}
                {...rest}
            />
            <div className="absolute w-auto h-4 bg-white -top-[11px] px-1 left-3 text-sm text-gray-500 cursor-default select-none">
                {filter?.name}
            </div>
        </div>
    );

}
